
$('.add-cart-icon').click(function () {
    let items = [
        {
            id: this.dataset.id,
            quantity: 1,
        },
    ];

    addCart(items);
});


function addCart(items) {
    return new Promise((resolve, reject) => {
        $.ajax({
            type: 'POST', 
            url: window.Shopify.routes.root + 'cart/add.js', 
            data: {
                items,
            },
            dataType: 'json',
            success: function (response) {
                resolve(response);
            },
            error: function (error) {
                reject(error);
            },
        });
    });
}
